import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Testimonials from '../homepage/Testimonials'
import { InlineSectionHeading } from './SectionHeading'

export const TestimonialsSection = ({ section, className = 'py-6 leading-loose' }) => {
  const { heading, content, fields } = section
  let paragraphWithUpdatedImages
  paragraphWithUpdatedImages = fields ? fields.contentImg : null
  const htmlToRender = paragraphWithUpdatedImages ? paragraphWithUpdatedImages : content

  const contentHtml = {
    __html: (heading ? InlineSectionHeading(heading) : '') + htmlToRender,
  }
  return (
    <section className={(className || 'leading-loose') + ' py-6'}>
      <div
        className="max-w-[1366px] mx-auto prose lg:prose-xl"
        dangerouslySetInnerHTML={contentHtml}
      />
      <Testimonials />
    </section>
  )
}

TestimonialsSection.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
    fields: PropTypes.shape({
      contentImg: PropTypes.string,
    }),
  }),
  className: PropTypes.string,
}

TestimonialsSection.defaultProps = {
  section: {
    heading: '',
    content: '',
    fields: {
      contentImg: '',
    },
  },
  className: 'py-6 leading-loose',
}

export const query = graphql`
  fragment TestimonialsSection on STRAPI__COMPONENT_SECTION_TESTIMONIALS {
    id
    heading
    strapi_component
    content
    #fields {
    #          contentImg
    #}
  }
`

export default TestimonialsSection
